import i18n from "../i18n/i18n";

export function validateUpdateInput({ username, oldPassword, newPassword }) {
  const trimmedName = username?.trim() || "";

  const noNameChange = trimmedName.length === 0;
  const noPasswordChange = !oldPassword && !newPassword;

  if (noNameChange && noPasswordChange) {
    return i18n.t("errors.noDataToUpdate", "You didn't provide any data to update.");
  }

  if (newPassword && !oldPassword) {
    return i18n.t("errors.enterCurrentPasswordToSetNew", "Please enter your current password to set a new one.");
  }

  if (oldPassword && !newPassword) {
    return i18n.t("errors.enterNewPasswordToChange", "Please enter a new password to change it.");
  }

  if (newPassword && newPassword.length < 8) {
    return i18n.t("errors.newPasswordMinLength", "New password should be at least 8 characters long.");
  }

  return null;
}

export function parseUpdateError(error) {
  const status = error?.status || error?.response?.status;
  const detail =
    error?.message ||
    error?.response?.data?.detail ||
    "Failed to update profile.";

  if (typeof detail === "string") {
    if (
      detail.toLowerCase().includes("old password") ||
      detail.toLowerCase().includes("current password")
    ) {
      return i18n.t("errors.currentPasswordIncorrect", "Current password is incorrect.");
    }
  }

  if (!status) {
    return i18n.t("errors.unexpectedError", "An unexpected error occurred. Please try again later.");
  }

  switch (status) {
    case 400:
      return i18n.t("errors.invalidDataCheckInput", "Invalid data. Please check your input.");
    case 401:
      return i18n.t("errors.sessionExpired", "Your session has expired. Please sign in again.");
    case 403:
      return i18n.t("errors.notAllowedToUpdate", "You are not allowed to update this account.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    case 502:
    case 503:
    case 504:
      return i18n.t("errors.serviceUnavailable", "Service is temporarily unavailable. Please try again in a moment.");
    default:
      return i18n.t("errors.couldNotUpdateProfile", "Could not update your profile. Please try again.");
  }
}
